module.exports = __webpack_public_path__ + "img/ml.d3a62cc9.png";